import {twMerge} from '../../../common/twMerge';
import {LOG_SEARCH_CLICK} from '../../../logging/logEvent';
import {putTiaraObjectProps} from '../../../logging/putTiaraObjectProps';
import {Text} from '../../atoms/Text/Text';
import {PopularSearchesItemProps} from './PopularSearchesItemProps.interface';

export function PopularSearchesItem({
  rank,
  keyword,
  isMobile,
  index,
  className,
  onClickItem,
  ...props
}: PopularSearchesItemProps) {
  return (
    <div
      className={twMerge(
        'flex items-center',
        !isMobile && 'hover:rounded-4pxr hover:bg-theme-solid-10',
        className
      )}
      onClick={event => {
        LOG_SEARCH_CLICK('인기검색어_클릭', event, () => onClickItem(keyword), {
          customPage: '검색_메인',
        });
      }}
      {...props}
      {...putTiaraObjectProps({
        actionKind: 'Search',
        click: {
          layer1: '인기검색어',
          ordnum: String(index + 1),
          copy: keyword,
        },
        search: {
          search_term: keyword,
          search_type: '인기검색어',
        },
      })}
    >
      <Text
        className={twMerge(
          'shrink-0',
          isMobile
            ? 'font-medium1-bold w-24pxr text-center'
            : 'font-small1-bold w-16pxr text-left',
          isMobile
            ? rank <= 3
              ? 'text-theme-solid-100'
              : 'text-theme-solid-100'
            : rank <= 3
              ? 'text-theme-solid-100'
              : 'text-theme-solid-60'
        )}
      >
        {rank}
      </Text>
      <Text
        className={twMerge(
          'text-theme-solid-100 line-clamp-1',
          isMobile ? 'font-medium2 ml-8pxr' : 'font-small1 ml-8pxr',
          !isMobile && rank > 3 && 'text-theme-solid-60'
        )}
      >
        {keyword}
      </Text>
    </div>
  );
}
